import Page from "../Common/Page";
import React from "react";
import { Row, Col, Divider, Space } from "antd";
import { Link } from "react-router-dom";

export default class CompletedPage extends React.Component<any> {
  private _page: React.RefObject<Page>;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
  }

  render() {
    return (
      <Page ref={this._page} noCheckAuthority={true}>
        <Row justify="center">
          <Col span={6}>
            <h1 className="iiscore-title">iiscore-U</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Divider orientation="left">パスワード変更完了</Divider>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={6}>
            <Space split={<Divider type="vertical" />} size={"large"}>
              パスワードの変更は完了しました。ログインにより、システムにログインして機能を利用することができます。
            </Space>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Space split={<Divider type="vertical" />} size={"large"}>
              　
            </Space>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={6}>
            <Space split={<Divider type="vertical" />} size={"large"}>
              <Link to={"/Login"}>ログインはこちら</Link>
            </Space>
          </Col>
        </Row>
      </Page>
    );
  }
}
